const OSM_OVERPASS_URL = 'https://overpass.osm.ch/api/interpreter';
const SWISS_HEIGHT_URL = 'https://api3.geo.admin.ch/rest/services/height';

export async function fetchOsmOverpass(query: string, signal?: AbortSignal) {
  return fetch(OSM_OVERPASS_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain',
    },
    body: query,
    signal,
  });
}

export async function fetchSwissHeight(easting: number, northing: number, signal?: AbortSignal) {
  const url = new URL(SWISS_HEIGHT_URL);
  url.searchParams.set('easting', String(easting));
  url.searchParams.set('northing', String(northing));

  return fetch(url.toString(), {
    signal,
  });
}
